/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";

import TableCell from "../../../../../components/TableCell";

export const ROUTE_PRODUCT_DETAILS_COLUMNS = [
  {
    Header: "Code",
    accessor: "Product.ProductCode"
  },
  {
    Header: "Description",
    accessor: "ProdDescription"
  },
  {
    Header: "Hazmat",
    accessor: "Product.HazmatCode"
  }
];

export const ROUTE_PRODUCT_BILLING_COLUMNS = [
  {
    Header: "Code",
    accessor: "Product.ProductCode"
  },
  {
    Header: "Description",
    accessor: "ProdDescription"
  },
  {
    Header: "Category",
    accessor: "Product.ProductCategory.CodeDescription"
  },
  {
    Header: "UOM",
    accessor: "UOM.CodeDescription",
    id: "UOM"
  },
  {
    Header: "Rate",
    accessor: "Rate",
    Cell: ({ cell }) => <TableCell.Number value={cell.value} />
  },
  {
    Header: "%",
    accessor: "Percentage",
    Cell: ({ cell }) => <TableCell.Percent value={cell.value} />
  },
  {
    Header: "External Comment",
    accessor: "ExternalComm"
  },
  {
    Header: "Internal Comment",
    accessor: "InternalComm"
  }
];
